import React from 'react';

export default () => {
  return (
    <div className="progress">
      <div className="indeterminate"></div>
    </div>
  );
};
